export enum PromptPersistActionTypeEnum {
  Reorder_NotRequired = 1,
  Reorder_NotRequired_DontPromptInStore = 2,
  YesAction_Only = 3,
  YesAction_DontPrompt_Checked = 4,
  YesAction_DontPrompt_UnChecked = 5,
  NoAction_Only = 6,
  NoAction_DontPrompt_Checked = 7,
  NoAction_DontPrompt_UnChecked = 8
}
